import * as React from 'react'

import styles from './MatchingItem.css'

export function MatchingHighlight({children}: {children?: string}): React.ReactElement {
  return (
    <span className={styles.match} data-test-agents-sidebar-matching-item>
      {children}
    </span>
  )
}

function MatchingTitle({
  children,
  searchQuery,
}: {
  children?: string | null
  searchQuery?: string
}): React.ReactElement | null {
  if (searchQuery == null || children == null) {
    return <>{children}</>
  }

  const matchStart = children.toLowerCase().indexOf(searchQuery.trim().toLowerCase())
  const matchEnd = matchStart + searchQuery.trim().length
  return matchStart === -1 ? (
    <>{children}</>
  ) : (
    <>
      {children.substring(0, matchStart)}
      <MatchingHighlight>{children.substring(matchStart, matchEnd)}</MatchingHighlight>
      {children.substring(matchEnd)}
    </>
  )
}

export default MatchingTitle
